"use client";

import { ChakraProvider, createSystem, defaultConfig } from "@chakra-ui/react";
import {
  ColorModeProvider,
  type ColorModeProviderProps,
} from "./color-mode";

// Criando um sistema personalizado com a fonte Inter e cor ""
const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      fonts: {
        heading: { value: "var(--font-inter)" },
        body: { value: "var(--font-inter)" },
        merriweather: { value: "var(--font-merriweather)" },
      },
      colors: {
        "red-wine": { value: "#8C1614" },
        "white-bg": { value: "#F4F4F4" },
      },
    },
  },
});

export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
}
